import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Users2 } from "lucide-react";

/**
 * Reusable "Filter by Team Lead" dropdown.
 *
 * Usage:
 *   const [tlId, setTlId] = useState("");
 *   <TeamLeadFilter value={tlId} onChange={setTlId} />
 *
 * Then filter your row set with: rows.filter(r => !tlId || tlId === "_all_" || r.team_lead_id === tlId)
 */
export default function TeamLeadFilter({ value, onChange, className = "", showLabel = true, testIdPrefix = "tl-filter" }) {
  const [tls, setTls] = useState([]);

  useEffect(() => {
    api.get("/reporting/team-leads")
      .then((r) => setTls(r.data || []))
      .catch(() => setTls([]));
  }, []);

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid={testIdPrefix}>
      {showLabel ? (
        <Label className="text-xs uppercase tracking-wider text-gray-500 flex items-center gap-1 whitespace-nowrap">
          <Users2 className="h-3.5 w-3.5" />Team Lead
        </Label>
      ) : null}
      <Select value={value || "_all_"} onValueChange={onChange}>
        <SelectTrigger className="h-9 min-w-[200px]" data-testid={`${testIdPrefix}-select`}>
          <SelectValue placeholder="All Team Leads" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="_all_" data-testid={`${testIdPrefix}-all`}>All Team Leads</SelectItem>
          {tls.map((tl) => (
            <SelectItem key={tl.employee_id} value={tl.employee_id} data-testid={`${testIdPrefix}-${tl.employee_id}`}>
              {tl.name} · <span className="text-gray-400 font-mono text-[10px]">{tl.employee_id}</span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
